<div class="tab-container">
    <div class="input-group">
        <div class="inline-group">
            <span class="input-group-title">Zuordnung</span>
        </div>

        <label [for]="'customer'">Kunde*</label>
        <ng-select [name]="'customer'"
                   [id]="'customer'"
                   required
                   [clearable]="false"
                   [ngModel]="model.selectedCustomer"
                   [compareWith]="compareCustomers"
                   (ngModelChange)="selectedCustomerChange($event)" placeholder="Kunden auswählen">
            <ng-option *ngFor="let customer of customerOptions" [value]="customer">{{ customer.customerName }}
            </ng-option>
        </ng-select>
    </div>

    <div class="input-group">
        <label [for]="'site'">Liegenschaft*</label>

        <ng-select [name]="'site'"
                   [id]="'site'"
                   required
                   [clearable]="false"
                   [ngModel]="model.selectedSite"
                   [compareWith]="compareById"
                   (ngModelChange)="selectedSiteChanged($event)">
            <ng-option
                    *ngFor="let site of ((model.additionalGateway ? installedSiteOptions : plannedSiteOptions) || [])"
                    [value]="site">{{ getSiteName(site) }}
            </ng-option>
        </ng-select>
    </div>

    <div class="input-group">
        <div class="inline-group">
            <span class="input-group-title">Module</span>
            <span>{{ model?.uvsModules?.length }} konfiguriert</span>
        </div>
        <div class="snap" [class.loading]="isModuleConfigLoading">
            <div>
                <b>Konfiguration</b>
                <span *ngIf="isModuleConfigLoading">Daten werden geladen …</span>
                <span *ngIf="!isModuleConfigLoading">Daten geladen {{ moduleConfigLoadedAt ? (moduleConfigLoadedAt | date: 'HH:mm') : '–' }} Uhr</span>
            </div>
            <button class="outline" [disabled]="isModuleConfigLoading || configurationBeingSent"
                    (click)="loadModuleConfig()">
                {{ isModuleConfigLoading ? 'Lädt …' : 'Daten neu laden' }}
            </button>
        </div>
        <div class="note err" *ngIf="unrecognizedModulesCount > 0">
            {{ unrecognizedModulesCount === 1 ? 'Ein Modul wird' : unrecognizedModulesCount + ' Module werden' }}
            vom Gateway nicht erkannt. Bitte Adresse und Typ prüfen und die Modulkonfiguration erneut senden.
        </div>
        <div class="module-list" [class.loading]="isDeviceDataLoading">
            <article class="mod" *ngFor="let module of model.uvsModules; index as i"
                     [class.is-error]="!module.markedForRemoval && getModuleStatus(module).kind === 'err'"
                     [class.is-removed]="module.markedForRemoval">
                <div class="mod-top">
                    <div class="adr">
                        <small>Adresse</small>
                        <b>{{ module.address }}</b>
                    </div>
                    <div class="mod-title">
                        <b>{{ getTypeLabel(module.uvsType) }}</b>
                        <span class="chip" *ngIf="!module.markedForRemoval" [ngClass]="getModuleStatus(module).kind">
                            <span class="dot"></span>{{ getModuleStatus(module).text }}
                        </span>
                    </div>
                    <button class="ghost" *ngIf="!module.markedForRemoval" (click)="toggleModule(module.address)">
                        {{ expandedModules.has(module.address) ? 'Weniger' : 'Konfiguration' }}
                    </button>
                </div>

                <p class="err-line" *ngIf="!module.markedForRemoval && getModuleError(module) as error">{{ error }}</p>

                <div class="cfg" *ngIf="expandedModules.has(module.address) && !module.markedForRemoval">
                    <dl *ngIf="getConfigRows(+module.address) as rows">
                        <ng-container *ngFor="let row of rows">
                            <dt>{{ row.label }}</dt>
                            <dd>{{ row.value }}</dd>
                        </ng-container>
                    </dl>
                    <p class="no-data" *ngIf="!getConfigRows(+module.address).length">
                        {{ getGatewayModule(module.address) ? 'Für dieses Modul gibt es keine Einstellungen.' : 'Das Gateway meldet für diese Adresse noch keine Konfiguration.' }}
                    </p>
                </div>

                <div class="mod-actions">
                    <button class="ghost" *ngIf="module.markedForRemoval" (click)="undoRemoveModule(i)">
                        Entfernen rückgängig
                    </button>
                    <ng-container *ngIf="!module.markedForRemoval">
                        <button class="ghost" [disabled]="isReadOnlyModule(module)" (click)="editModule(i)">Bearbeiten</button>
                        <button class="ghost danger" [disabled]="activeModulesCount <= 1 || isReadOnlyModule(module)"
                                (click)="removeModuleSelection(i)">Entfernen
                        </button>
                    </ng-container>
                </div>
            </article>
        </div>

        <div style="color: red">
            <span *ngIf="currentModuleComparison < 0">
                Sie haben weniger Module ausgewählt, als in den Gatewayrohdaten angezeigt werden. Klicken Sie bitte
                auf den Button <strong>Modulkonfiguration senden</strong>, um die Module zu aktualisieren.
            </span>
        </div>

        <div class="buttons">
            <button class="add" [disabled]="model.uvsModules.length >= 25" (click)="addModuleSelection()">
                + Modul hinzufügen
            </button>
        </div>

        <div class="pending" *ngIf="unsentChangesCount > 0 || configurationBeingSent">
            <div>
                <b>{{ unsentChangesCount }} {{ unsentChangesCount === 1 ? 'Änderung' : 'Änderungen' }} noch nicht
                    gesendet</b>
                <p>Die Module werden mit der Konfiguration im Gateway abgeglichen. Gesendet wird erst mit
                    „Prüfen und senden“.</p>
            </div>
            <div class="row">
                <button class="cancel" [disabled]="configurationBeingSent" (click)="discardModuleChanges()">
                    Verwerfen
                </button>
                <button *ngIf="!configurationBeingSent" class="send" [disabled]="!canSendModuleSelections()"
                        (click)="reviewAndSend()">Prüfen und senden
                </button>
                <button *ngIf="configurationBeingSent" class="send" [disabled]="true">Konfiguration wird gesendet
                </button>
            </div>
        </div>
        <div class="timer"
             *ngIf="configurationBeingSent && !(timerForConfigWaitTime | async) && (timerForConfigWaitTime | async) !== 0">
            <span>Daten werden geladen</span>
            <span class="loading">
                <img src="./assets/images/icons/refresh.svg"/>
            </span>
        </div>
        <div class="timer" *ngIf="(timerForConfigWaitTime | async) !== null">
            <span>Bitte warten</span>
            <div class="progress-bar">
                <span class="label">{{ (timerForConfigWaitTime | async) }} / {{ configWaitTime }}</span>
                <div class="progress" [style.width.%]="((timerForConfigWaitTime | async) / configWaitTime) * 100"></div>
            </div>
        </div>
    </div>

    <div class="input-group">
        <label for="addressComment">Kommentar zur Adresse</label>
        <input type="text"
               name="addressComment"
               id="addressComment"
               [(ngModel)]="model.addressComment">
    </div>
    <div class="input-group">
        <label for="locationComment">Kommentar zum Ort des Gateways</label>
        <input type="text"
               name="locationComment"
               id="locationComment"
               [(ngModel)]="model.locationComment">
    </div>
</div>
<div class="field">Pflichtfelder*</div>
<p class="next-hint" *ngIf="nextBlockedReason">{{ nextBlockedReason }}</p>
<app-navigation-footer
        [isBackLinkDisabled]="true"
        [backLink]=""
        [isNextLinkDisabled]="!validationService.isGeneralGatewayValid(model) || !!nextBlockedReason"
        [nextLink]="'/gateway/general/pre-photos'"
        [isLast]="false"
></app-navigation-footer>
